import { render, staticRenderFns } from "./AssignmentTimeslot.vue?vue&type=template&id=1614cf1c&scoped=true&"
import script from "./AssignmentTimeslot.vue?vue&type=script&lang=js&"
export * from "./AssignmentTimeslot.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentTimeslot.vue?vue&type=style&index=0&id=1614cf1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1614cf1c",
  null
  
)

export default component.exports